'use client';

import { useCallback, useContext } from 'react';
import ComposerUiWidget from '@/common/ComposerUi/ComposerUiWidget';
import StaticContext from '~/context/common/StaticContext';
import { useModalContext } from '~/context/home/ModalContext/ModalContext';

export default function HomeComposerUi() {
  const { showComposerUi } = useContext(StaticContext);
  const { isComposerUiModalOpen, setComposerUiModalOpen } = useModalContext();

  const handleClose = useCallback(
    () => setComposerUiModalOpen(false),
    [setComposerUiModalOpen]
  );
  const handleOpen = useCallback(
    () => setComposerUiModalOpen(true),
    [setComposerUiModalOpen]
  );

  if (!showComposerUi) return null;

  return (
    <ComposerUiWidget
      isOpen={isComposerUiModalOpen}
      onClose={handleClose}
      onOpen={handleOpen}
    />
  );
}
